/*
 * Author M. Atoar Rahman
 * Title: Current Stock By Date
 * Description: Page for Current Stock By Date
 */

import { useAuth } from '../../contexts/AuthContext';
import { CurrentStockByDateProvider } from '../misReports/currentStockByDate/ContextAPI';
import Index from '../misReports/currentStockByDate/Index';
import PermissionDenied from './PermissionDenied';

export default function CurrentStockByDate() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-register']) return <PermissionDenied />;

    return (
        <CurrentStockByDateProvider>
            <Index />
        </CurrentStockByDateProvider>
    );
}